/**
 * /settings/custom-login-domain — operator page for FS-676.
 *
 * Declares a TanStack Router route and renders the
 * `CustomLoginDomainPage` feature. Root wire-up picks this up from
 * `router.tsx`.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { CustomLoginDomainPage } from "@/features/custom-login-domain/CustomLoginDomainPage";

export const settingsCustomLoginDomainRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/settings/custom-login-domain",
	component: SettingsCustomLoginDomainRoute,
});

export default settingsCustomLoginDomainRoute;

export function SettingsCustomLoginDomainRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-5xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Settings</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">Custom login domain</li>
				</ol>
			</nav>

			<CustomLoginDomainPage />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { SettingsCustomLoginDomainRoute as SettingsCustomLoginDomainPage };
